// extracted by mini-css-extract-plugin
export default {"iFrameDiv":"video-player_iFrameDiv__GsA5h"};